import { render, staticRenderFns } from "./CarsReports.vue?vue&type=template&id=23830f74"
import script from "./CarsReports.vue?vue&type=script&lang=js"
export * from "./CarsReports.vue?vue&type=script&lang=js"
import style0 from "./CarsReports.vue?vue&type=style&index=0&id=23830f74&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports